import { BASE_URL } from '../../service/RequestService';

export const widgetFIleURL = `${BASE_URL}/files/widget/`;
